import React from 'react';
import { Check, ShieldCheck } from 'lucide-react';

export const AuthIntro = () => <div className="auth-intro">
  <span className="eyebrow">YOUR NEXT BUSINESS ADVANTAGE</span>
  <h1>Good business<br />starts here.</h1>
  <p>A dedicated space for your sourcing, suppliers<br />and next big opportunity.</p>
  <div className="auth-benefits">
    {['Wholesale pricing for your quantities', 'Quotes tailored to your requirements', 'Purchase orders, all in one place']
      .map(text => <span key={text}><Check size={17} />{text}</span>)}
  </div>
  <div className="auth-review-note"><ShieldCheck size={23} /><div><strong>For registered businesses</strong>
    <p>GSTIN format is checked at signup. Business approval is reviewed manually.</p></div></div>
</div>;